import { CreditorHistoryDetail } from '@shared/types'

type CreditorHistoryDetailTableData = Omit<CreditorHistoryDetail, '__typename' | 'stationBrand'>
type CreditorHistoryDetailProperty = keyof CreditorHistoryDetailTableData

// This is in the same order as the columns in the creditor history table
export const keyToLabelMap: Record<CreditorHistoryDetailProperty, string> = {
  stationRecordNumber: 'P Org',
  paymentDate: 'Payment Date',
  totalBalesInPayment: 'Bales',
  totalNetKgInPayment: 'Net Kg',
  saleAndSeason: 'Sale',
  grossProceedsExGST: 'Gross Proceeds (excl GST)',
  netProceedsGSTInclusive: 'Net Proceeds',
  accountSalesDate: 'Acc Sales Date',
}

export const convertCreditorHistoryKeysToLabels = (
  creditorHistoryDetails: CreditorHistoryDetail[]
): Record<CreditorHistoryDetailProperty, any>[] => {
  const convertedDetails: Record<CreditorHistoryDetailProperty, any>[] = []
  creditorHistoryDetails.forEach((creditorHistoryDetail) => {
    const converted: Record<string, any> = {}
    // Convert keys using the keyToLabelMap so that the CSV header matches the table header
    Object.keys(keyToLabelMap).forEach((key) => {
      if (key === 'stationRecordNumber') {
        // Combine station record number and brand for the P Org column
        converted[keyToLabelMap[key as CreditorHistoryDetailProperty]] =
          `${creditorHistoryDetail.stationRecordNumber} ${creditorHistoryDetail.stationBrand}`
      } else {
        // For other keys, just map them directly
        converted[keyToLabelMap[key as CreditorHistoryDetailProperty]] =
          creditorHistoryDetail[key as CreditorHistoryDetailProperty]
      }
    })
    convertedDetails.push(converted)
  })
  return convertedDetails
}
